














import { Component, Prop, Vue } from "vue-property-decorator";
import VCheckButton from "./VCheckButton.vue";

export interface VCheckButtonRadioValue {
  [Key: string]: boolean;
}

export interface VCheckButtonRadioOptions {
  [Key: string]: string;
}

@Component({
  components: {
    VCheckButton,
  },
})
export default class VCheckButtonRadio extends Vue {
  @Prop() readonly value!: string;
  @Prop() readonly options!: VCheckButtonRadioOptions;
  @Prop({ default: false }) readonly asRadio!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;

  selected: VCheckButtonRadioValue = {};

  created() {
    for (const key in this.options) {
      this.$set(this.selected, key, key == this.value);
    }
  }

  onChecked(value: boolean, key: string) {
    this.selected[key] = true;

    for (const optionKey in this.options) {
      if (optionKey !== key) {
        this.selected[optionKey] = false;
      }
    }

    this.$emit("input", key);
  }
}
